import { BED_COUNTS } from 'shared/constants'
import { FilterSelector } from '../../presentations/FilterSelector'

interface BedsFilterContainerProps {
    open: boolean
    onOpen?: (event: any) => void
    onClose?: (event: any) => void
    onSelectedItemsChanged?: (event: any) => void
    initialSelectedItems: any[]
    propertyName?: string
}

export const BedsFilterContainer = (props: BedsFilterContainerProps): JSX.Element => {
    const {
        open,
        onOpen,
        onClose,
        propertyName,
        initialSelectedItems,
        onSelectedItemsChanged
    } = props

    return (
        <>
            <FilterSelector
                text={'Beds'}
                items={BED_COUNTS}
                open={open}
                propertyName={propertyName}
                onOpen={onOpen}
                onClose={onClose}
                initialSelectedItems={initialSelectedItems}
                onSelectedItemsChanged={onSelectedItemsChanged}
            />
        </>
    )
}